export default __webpack_public_path__ + "static/media/cineonhub_hover_change.179c074c.svg";